import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { history } from "../../../../store/configure/configureStore";
import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import queryString from "query-string";
import { setUnblock } from "../../../../navigation/navigationBlocker";
import ContentDetailsView from "./ContentDetailsView";
import { Role } from "../../../../constants/role";
import { YOU_TUBE } from "../../../../constants/constants";
//
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";
import {
  getYouTubeList,
  addYouTubePublished,
  getYouTubeVideoById,
  uploadYoutubeThumbnail,
  setNavigatingToOtherPageWarningModal,
} from "../../../../store/YouTubeManagement/YouTubeManagementActions";
import { sendNotificationForPublishedVideos } from "../../../../store/notificationManagement/notificationManagementActions";
import {
  getCategoryList,
  getTagsList,
  getStatusList,
  getLanguagesList,
  addNewTag,
} from "../../../../store/master/masterActions";

class ContentDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        showSendNotificationModal: false,
        showImageModal: false,
        showDeleteModal: false,
      },
      fields: {
        title: "",
        description: "",
        category: { label: "", value: "" },
        status: { label: "", value: "" },
        language: { label: "", value: "" },
        genre: "",
        metaData: "",
        fileURL: "",
        file: "",
        thumbnail: "",
      },
      errors: {},
      genres: [], //this state is used for displaying saved genres below the genre dropdown
      page: "",
      limit: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleSubCategoryChange = this.handleSubCategoryChange.bind(this);
    this.handleGenreChange = this.handleGenreChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.handleRemoveGenre = this.handleRemoveGenre.bind(this);
    this.autoFillValue = this.autoFillValue.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    //
    // this.handelUpdateIds = this.handelUpdateIds.bind(this);
    this.handleInitialGenres = this.handleInitialGenres.bind(this);
    //
    // this.onClickAddTag = this.onClickAddTag.bind(this);
    this.onClickCancelButton = this.onClickCancelButton.bind(this);
    this.onClickContentDetailsSubmit =
      this.onClickContentDetailsSubmit.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("state verification", this.state);
    if (prevProps?.youtubeList !== this.props?.youtubeList) {
      setTimeout(() => {
        this.autoFillValue();
      }, [1000]);
    }
  }

  componentDidMount() {
    const { id } = this.props.match?.params;
    this.props.getYouTubeVideoById(id, () =>
      // this.handleInitialGenres(this.props.youtubeList?.tag)
      this.handleInitialGenres(this.props.youtubeList?.subCategory)
    );

    this.unblock = history.block((location, action) => {
      // console.log("location", location);
      const { showSelection, selectedMultipleRowVideo } = this.props;
      const showSelectionIsTrue = showSelection;
      const isRowsSelected = selectedMultipleRowVideo?.length > 0;
      const shouldBlock = showSelectionIsTrue && isRowsSelected; // replace with your condition

      // Check if the current path should not block navigation
      const shouldAllowNavigation =
        location?.pathname?.includes("/media/content-detail/youtube") ||
        location?.pathname?.includes("/media/youtube-management");

      //allow navigation only for the above paths
      if (shouldBlock && !shouldAllowNavigation) {
        // Prevent navigation
        this.props.setNavigatingToOtherPageWarningModal(
          true,
          location?.pathname
        );
        return false; // Prevent the default behavior
      }
    });
    setUnblock(this.unblock); // Set the unblock function globally

    //
    this.props.getCategoryList();
    this.props.getTagsList();
    this.props.getStatusList();
    this.props.getLanguagesList();

    //--------------------------get parameters from url
    const parsed = queryString.parse(window.location.search);
    const page = parsed.page;
    const limit = parsed.limit;

    this.setState((prev) => ({ prev, page: page, limit: limit }));
  }

  componentWillUnmount() {}

  //--------------------------field handlers
  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    // this.setState({
    //   fields: { ...this.state.fields, [field]: target.value },
    //   errors: {},
    // });

    this.setState((prev) => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors[field]; // Remove the error for the updated field
      return {
        ...prev,
        fields: { ...this.state.fields, [field]: target.value },
        errors: updatedErrors,
      };
    });
  };

  handleCategoryChange = (value) => {
    console.log(this.state.fields);
    // this.setState({
    //   fields: { ...this.state.fields, category: value },
    // });

    this.setState((prev) => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors["category"]; // Remove the error for the updated field
      return {
        ...prev,
        fields: { ...this.state.fields, category: value },
        errors: updatedErrors,
      };
    });
  };

  handleFileChange(event) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.setState((prev) => ({
          ...prev,
          fields: { ...prev.fields, fileURL: reader.result },
        }));
      };

      reader.readAsDataURL(file);

      this.setState(
        (prev) => ({
          ...prev,
          fields: { ...prev.fields, file: file },
        }),
        () => {
          // Reset file input value to allow re-uploading the same file
          event.target.value = null;
        }
      );
    }
  }

  handleRemoveFile = () => {
    this.setState(
      (prev) => ({
        ...prev,
        fields: { ...prev.fields, file: "", fileURL: "" },
      }),
      () => this.onCloseModal()
    );
  };

  handleStatusChange = (value) => {
    console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, status: value },
    });
  };

  handleLanguageChange = (value) => {
    console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, language: value },
    });
  };

  handleTitleChange = (e) => {
    console.log(this.state.fields);
    const { value } = e.target;
    this.setState({
      fields: { ...this.state.fields, title: value },
    });
  };

  handleDescriptionChange = (e) => {
    console.log(this.state.fields);
    const { value } = e.target;
    this.setState({
      fields: { ...this.state.fields, description: value },
    });
  };

  autoFillValue = () => {
    const { youtubeList, languages } = this.props;
    console.log("youtubelist", youtubeList);

    let filteredLanguage = languages?.filter(
      (item) => item.code === youtubeList?.defaultAudioLanguage
    );
    // If no matching language is found, include items with the code "en"
    if (!filteredLanguage?.length) {
      filteredLanguage = languages?.filter((item) => item.code === "en");
    }

    const existingTitleValue = youtubeList?.title ? youtubeList?.title : null;

    const existingDescriptionValue = youtubeList?.description
      ? youtubeList?.description
      : null;

    const existingThumbnailValue = youtubeList?.thumbnails
      ? youtubeList?.thumbnails?.high?.url
      : null;

    // const existingCategoryValue = youtubeList?.categoryId?.[0]?.categoryName
    //   ? {
    //       label: youtubeList?.categoryId?.[0]?.categoryName,
    //       value: youtubeList?.categoryId?.[0]?._id,
    //     }
    //   : null;
    const existingCategoryValue = youtubeList?.categoryId?.categoryName
      ? {
          label: youtubeList?.categoryId?.categoryName,
          value: youtubeList?.categoryId?._id,
        }
      : null;

    const existingLanguagesValue = youtubeList?.languageId?.name
      ? {
          label: youtubeList?.languageId?.name,
          value: youtubeList?.languageId?._id,
        }
      : {
          label: filteredLanguage?.[0]?.name,
          value: filteredLanguage?.[0]?._id,
        };

    const existingStatusValue = youtubeList?.status?.[0]?.status
      ? {
          label: youtubeList?.status?.[0]?.status,
          value: youtubeList?.status?.[0]?._id,
        }
      : null;

    const existingMetaDataValue = youtubeList?.stringTags
      ? youtubeList?.stringTags
      : "";

    // Convert the file to base64
    const file = youtubeList?.customParameters;
    // const fileURL = file ? this.convertFileToBase64(file) : null;

    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          title: existingTitleValue,
          description: existingDescriptionValue,
          category: existingCategoryValue,
          language: existingLanguagesValue,
          status: existingStatusValue,
          metaData: existingMetaDataValue,
          file: null,
          fileURL: file || null, // Set the base64 string here
          thumbnail: existingThumbnailValue,
        },
      }),
      () => console.log("state of autofill", this.state?.fields)
    );
  };

  // Function to convert file to base64
  convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // This will give the base64 string
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  //--------------------------Sub-Category
  handleSubCategoryChange = (value, newTags) => {
    //-------------------------------
    // console.log("value", value);
    // console.log("newTags", newTags);

    const { fields } = this.state;

    this.setState(
      {
        fields: {
          ...fields,
          metaData: value,
          // newSubCategory: createdValue,
        },
      },
      () => {
        // console.log("latest existed state", this.state.fields.genre);
        // console.log("latest new state", this.state.fields.newTag);
      }
    );
  };

  //--------------------------genres

  handleGenreChange = (value) => {
    //-------------------------------
    // console.log("value", value);
    // console.log("newTags", newTags);

    const { fields } = this.state;

    // let updatedGenreArray = fields.genre ? [...fields.genre] : [];

    let savedGenres = this?.state?.genres; //saved genres
    let updatedGenreArray = [];

    const capitalizeFirstLetter = (string) => {
      return string
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    };

    value?.forEach((value) => {
      const label = value?.label?.trim();
      console.log("label", label);

      const capitalizedLabel = capitalizeFirstLetter(label);

      //   // Check if a genre with the same label already exists
      const genreExists = updatedGenreArray.some(
        (genre) => genre.label === capitalizedLabel
      );

      if (!genreExists) {
        const newTag = {
          label: capitalizedLabel,
          value: value.__isNew__ ? capitalizedLabel : value.value,
          ...(value.__isNew__ && { __isNew__: true }), // Add __isNew__ property only if it exists in the value object
        };
        updatedGenreArray.push(newTag);
      }
    });

    const allGenres = [...savedGenres, ...updatedGenreArray]; //merge the saved genres and new genres
    // console.log("allGenres", allGenres);

    // this.setState(
    //   {
    //     fields: {
    //       ...fields,
    //       genre: allGenres,
    //     },
    //   },
    //   () => {
    //     // console.log("latest existed state", this.state.fields.genre);
    //   }
    // );

    this.setState((prev) => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors["genre"]; // Remove the error for the updated field
      return {
        ...prev,
        fields: {
          ...fields,
          genre: allGenres,
        },
        errors: updatedErrors,
      };
    });
  };

  //--------------------------Remove genre
  handleRemoveGenre = (index) => {
    //---------------
    console.log("fields genre", this.state.fields.genre);
    console.log("UI genre", this.state.genres);

    const genreLabel = this.state.genres[index].label;

    this.setState(
      (prevState) => ({
        genres: prevState?.genres?.filter((_, i) => i !== index), //exclude the element which match the index
        fields: {
          ...prevState.fields,
          genre: prevState.fields?.genre?.filter(
            (genre) => genre.label !== genreLabel
          ), //exclude the matched label element
        },
      }),
      () => console.log("callback log", this.state.genres)
    );
  };

  //--------------------------Already existing genres of Youtube video

  handleInitialGenres = (tagValue) => {
    const formattedGenres =
      tagValue?.map((genre) => ({
        value: genre._id,
        label: genre.tag,
      })) || [];

    this.setState((prev) => ({
      ...prev,
      fields: { genre: [...formattedGenres] },
      genres: [...formattedGenres],
    }));
  };

  //--------------------------thumbnail API
  uploadThumbnail = (youtubeVideoId) => {
    const { fileURL, file } = this.state.fields;
    const formData = new FormData();

    formData.append("youtubeVideoId", youtubeVideoId); // Append youtube video ID
    formData.append("file", file); // Append the file

    if (file) {
      this.props.uploadYoutubeThumbnail(formData);
    }
  };

  //--------------------------Update youtube video status/category/genre
  onClickContentDetailsSubmit = (id, isPublished, data) => {
    const { page, limit } = this.state;
    var fields = this.state.fields;
    const existingData = data; //this is data from youtubeList API

    //extracted fields value for validation
    const fieldsData = {
      category: fields?.category?.value,
      language: fields.language?.value,
      status: fields.status?.value,
      genre: fields?.genre?.length > 0 ? fields.genre[0] : "",
      metaData: fields?.metaData ? fields?.metaData : "",
    };

    // console.log("fieldsData", fieldsData);

    // const validatorFields =
    //   isPublished === true
    //     ? {
    //         required: ["category", "metaData", "genre", "language", "status"],
    //       }
    //     : { required: [] };

    // Skip the category validation when video type is "Shorts"
    const isShorts = this.props.youtubeList.contentType === "Shorts";
    const validatorFields = isPublished
      ? {
          required: isShorts
            ? ["metaData", "genre", "language", "status"] // Exclude "category"
            : ["category", "metaData", "genre", "language", "status"],
        }
      : { required: [] };

    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fieldsData)
    );
    // console.log("errors", errors);
    this.setState({ ...this.state, errors }, () => {
      var fields = this.state.fields;
      if (!Object.keys(errors).length) {
        // Function to capitalize the first letter of each word
        const capitalizeWords = (str) => {
          return str
            .split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");
        };

        const allGenres = this.state.fields.genre;

        const allGenreLabel = allGenres?.map((item) =>
          capitalizeWords(item.label)
        );

        //if video type is shorts then categoryId should contain id of shorts option
        const categoryId = isShorts
          ? this.props.categories.find((cat) => cat.categoryName === "Shorts")
              ?._id
          : fields?.category?.value || existingData?.category;

        // console.log("allGenreLabel", allGenreLabel);

        const data = {
          // categoryId: fields?.category?.value || existingData?.category,
          categoryId: categoryId,
          status: fields?.status?.value || existingData?.status,
          subCategory: allGenreLabel.length > 0 ? allGenreLabel : [], //genre
          stringTags: fields?.metaData ? fields?.metaData : "", //metaData
          languageId: fields?.language?.value || existingData?.language,
        };
        console.log("json API data", data);
        this.props.addYouTubePublished(id, data, page, limit, () => {
          // this.uploadThumbnail(id);
          // history.push(`/media/youtube-management`);
          const { id } = this.props.match?.params;
          this.props.getYouTubeVideoById(id, () => {});
        });
      }
    });
  };

  onClickNotify = () => {
    const { title, description } = this.state?.fields;
    const { thumbnails } = this.props.youtubeList;

    // Limit title to 30 characters and description to 100 characters
    const trimmedTitle = title?.substring(0, 30) || "";
    const trimmedDescription = description?.substring(0, 100) || "";

    const data = {
      title: trimmedTitle,
      body: trimmedDescription,
      imageUrl: thumbnails?.high?.url,
      topic: YOU_TUBE,
    };

    // console.log("data", data);

    this.props.sendNotificationForPublishedVideos(data, () =>
      this.onCloseModal()
    );
  };

  //--------------------------Cancel
  onClickCancelButton = () => {
    const videosByDailyCronType =
      youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const videosByUrlType = youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;
    const { page, limit } = this.state;

    const dynamicVideoType =
      this.props.activeNavTab === videosByUrlType
        ? videosByUrlType
        : videosByDailyCronType;

    // console.log("page", page);
    // console.log("limit", limit);
    // const data = {};

    //if filtered is applied then this data used
    const data = {
      title: this.props.titleSearch,
      status: this.props.statusSearch,
      languageId: this.props.languageSearch,
      channelId: this.props.channelSearch,
    };
    //on cancel just clear the id from localstorage
    localStorage.removeItem("videoId");
    history.push("/media/youtube-management");
    // const isRedirected = true;
    // this.props.getYouTubeList(
    //   data,
    //   page,
    //   limit,
    //   // videosByDailyCronType,
    //   dynamicVideoType,
    //   isRedirected
    // );
  };

  //---------------Modal handler
  onClickSendNotification = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showSendNotificationModal: true },
    }));
  };

  onClickImageTitle = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showImageModal: true },
    }));
  };

  onClickDeleteFile = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showDeleteModal: true },
    }));
  };

  onCloseModal = () => {
    this.setState(
      (prevState) => ({
        showModal: {
          showSendNotificationModal: false,
          showImageModal: false,
          showDeleteModal: false,
        },
      }),
      () => this.autoFillValue()
    );
  };

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    const editor = this.props.userRole === Role.Editor;

    const parsed = queryString.parse(window.location.search);
    const dataId = parsed.id;
    // console.log("dataId", dataId);

    //--------------------------dropdown options
    // const categoryDropDownOptions = this.props.categories?.map((item) => {
    //   return {
    //     label: item?.categoryName,
    //     value: item?._id,
    //   };
    // });

    const categoryDropDownOptions = this.props.categories
      ?.map((item) => ({
        label: item?.categoryName,
        value: item?._id,
      }))
      .filter((option) => {
        // Check the contentType and filter accordingly
        if (this.props.youtubeList?.contentType === "Shorts") {
          // Keep only the "Shorts" option
          return option.label === "Shorts";
        } else {
          // Exclude the "Shorts" option
          return option.label !== "Shorts";
        }
      });

    const isPublished =
      this.props.youtubeList?.status?.[0]?.status === "Published";

    const filteredStatus =
      isPublished === true && this.props?.status?.length > 0
        ? this.props?.status?.filter((item) => item.status != "Published")
        : this.props?.status?.filter((item) => item.status != "Unpublished");

    // const statusDropDownOptions = filteredStatus?.map((item) => {
    //   return {
    //     label: item?.status,
    //     value: item?._id,
    //   };
    // });

    const statusDropDownOptions = filteredStatus
      ?.map((item) => ({
        label: item?.status,
        value: item?._id,
      }))
      .filter((option) => {
        // If the user role is Editor, keep only the "Reviewed" option
        if (editor) {
          return option.label === "Reviewed";
        }

        // Otherwise, include all statuses
        return true;
      });

    const tagDropDownOptions = this.props?.tags?.map((item) => {
      return {
        label: item?.tag,
        value: item?._id,
      };
    });

    const LanguagesDropDownOptions = this.props?.languages?.map((item) => {
      return {
        label: item?.name,
        value: item?._id,
      };
    });

    // console.log(this.props.youtubeList);

    return (
      <ContentDetailsView
        //all the states
        showModal={this.state.showModal}
        fields={this.state?.fields}
        youtubeList={this.props.youtubeList}
        genres={this.state.genres}
        errors={this.state.errors}
        page={this.state.page}
        limit={this.state.limit}
        languages={this.props.languages}
        activeNavTab={this.props.activeNavTab}
        editor={editor}
        showSelection={this.props.showSelection}
        //input handler
        handleInputChange={this.handleInputChange}
        handleTitleChange={this.handleTitleChange}
        handleDescriptionChange={this.handleDescriptionChange}
        handleCategoryChange={this.handleCategoryChange}
        handleSubCategoryChange={this.handleSubCategoryChange}
        handleGenreChange={this.handleGenreChange}
        handleStatusChange={this.handleStatusChange}
        handleLanguageChange={this.handleLanguageChange}
        handleRemoveGenre={this.handleRemoveGenre}
        autoFillValue={this.autoFillValue}
        handleFileChange={this.handleFileChange}
        handleRemoveFile={this.handleRemoveFile}
        //modal
        onClickSendNotification={this.onClickSendNotification}
        onClickImageTitle={this.onClickImageTitle}
        onClickDeleteFile={this.onClickDeleteFile}
        handleCloseModal={this.onCloseModal}
        //
        handelUpdateIds={this.handelUpdateIds}
        handleInitialGenres={this.handleInitialGenres}
        //APIs
        onClickAddTag={this.onClickAddTag}
        onClickContentDetailsSubmit={this.onClickContentDetailsSubmit}
        onClickNotify={this.onClickNotify}
        onClickCancelButton={this.onClickCancelButton}
        //dropdown Options
        categoryDropDownOptions={categoryDropDownOptions}
        statusDropDownOptions={statusDropDownOptions}
        tagDropDownOptions={tagDropDownOptions}
        LanguagesDropDownOptions={LanguagesDropDownOptions}
        //
        userRole={this.props.userRole}
        userPermissions={this.props.userPermissions}
        //
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

ContentDetailsContainer.propTypes = {};

const mapStateToProps = (state) => ({
  youtubeList: state.youtubeManagement.youtubeList,
  categories: state.master.categories,
  tags: state.master.tags,
  status: state.master.status,
  languages: state.master.languages,
  userRole: state.auth.userRole,
  userPermissions: state.auth.userPermissions,
  activeNavTab: state.youtubeManagement.activeNavTab,
  activeNavTab: state.youtubeManagement.activeNavTab,
  showSelection: state.youtubeManagement.showSelection,
  //
  titleSearch: state.youtubeManagement.titleSearch,
  statusSearch: state.youtubeManagement.statusSearch,
  languageSearch: state.youtubeManagement.languageSearch,
  channelSearch: state.youtubeManagement.channelSearch,
  activeNavTab: state.youtubeManagement.activeNavTab,
  //
  showSelection: state.youtubeManagement.showSelection,
  selectedMultipleRowVideo: state.youtubeManagement.selectedMultipleRowVideo,
});

export default connect(mapStateToProps, {
  getYouTubeVideoById,
  getYouTubeList,
  getCategoryList,
  getTagsList,
  getStatusList,
  getLanguagesList,
  addNewTag,
  addYouTubePublished,
  uploadYoutubeThumbnail,
  sendNotificationForPublishedVideos,
  setNavigatingToOtherPageWarningModal,
})(ContentDetailsContainer);
